export const eventTypes = [
  { id: false, name: "All Events" },
  { id: true, name: "Home Events" },
];

export const status = [
  { name: "All", value: "all" },
  { name: "Active", value: "active" },
  { name: "Inactive", value: "inactive" },
];
